module.exports = __webpack_public_path__ + "media/images/service-single/feature5-827762020b579772ce35494b6365e84c.jpg";